module.exports = __webpack_public_path__ + "img/chinesecompany38.bc18dcb8.png";